import { render, staticRenderFns } from "./updateStaffSchedule.vue?vue&type=template&id=1167fca0&scoped=true&"
import script from "./updateStaffSchedule.vue?vue&type=script&lang=js&"
export * from "./updateStaffSchedule.vue?vue&type=script&lang=js&"
import style0 from "./updateStaffSchedule.vue?vue&type=style&index=0&id=1167fca0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1167fca0",
  null
  
)

export default component.exports